export default __webpack_public_path__ + "static/media/logo.f9a064a2.jpg";